// Polyfill everything:
import 'core-js/stable';

import './jquery';
import 'jquery.cookie';
